import { observer } from 'mobx-react-lite'
import React, { Fragment, useContext } from 'react'
import { Instagram, Linkedin, Pinterest, Tiktok, Youtube, Headphones, Stars } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'

export default observer(function Platforms() {
  const { campaign } = useContext(CampaignContext)

  return (
    <Fragment>
      <div className="mt-8 mb-4">
        <p className="font-bold">Platforms</p>
      </div>
      <div className="flex gap-2 w-full mb-4">
        {campaign.platforms.has('instagram') && <div className={`w-full px-4 py-6 h-7 rounded-lg border-1 bg-white text-pink-600 flex items-center`}><Instagram /><p className="ml-4">Instagram</p></div>}
        {campaign.platforms.has('tiktok') && <div className={`w-full px-4 py-6 h-7 rounded-lg border-1 bg-white text-black flex items-center`}><Tiktok /><p className="ml-4">Tiktok</p></div>}
        {campaign.platforms.has('youtube') && <div className={`w-full px-4 py-6 h-7 rounded-lg border-1 bg-white text-red-500 flex items-center`}><Youtube /><p className="ml-4">Youtube</p></div>}
        {campaign.platforms.has('pinterest') && <div className={`w-full px-4 py-6 h-7 rounded-lg border-1 bg-white text-red-500 flex items-center`}><Pinterest /><p className="ml-4">Pinterest</p></div>}
        {campaign.platforms.has('linkedin') && <div className={`w-full px-4 py-6 h-7 rounded-lg border-1 bg-white text-blue-500 flex items-center`}><Linkedin /><p className="ml-4">Linkedin</p></div>}
        {campaign.platforms.has('podcast') && <div className={`w-full px-4 py-6 h-7 rounded-lg border-1 bg-white text-gray-700 flex items-center`}><Headphones /><p className="ml-4">Podcast</p></div>}
        {campaign.platforms.has('other') && <div className={`w-full px-4 py-6 h-7 rounded-lg border-1 bg-white text-amber-600 flex items-center`}><Stars /><p className="ml-4">Other</p></div>}
      </div>

      <div className="border-1 w-full border-gray-100" />
    </Fragment>
  )
})